import React from "react";
import type { CheckboxProps } from "@mui/joy";
import { Checkbox } from "@mui/joy";
import { colorTokens, withAlpha } from "../../styles/globalStyles";

/**
 * Dark-themed Checkbox component with consistent styling across the app.
 */
const DarkCheckbox = React.forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
  const { sx, ...other } = props;

  const darkCheckboxStyles = {
    "--Checkbox-size": "18px",
    "--Icon-fontSize": "14px",
    color: colorTokens.text.secondary,
    "& .MuiCheckbox-checkbox": {
      backgroundColor: colorTokens.text.primary,
      borderColor: colorTokens.border.strong,
      borderRadius: "6px",
    },
    "& .MuiCheckbox-label": {
      color: colorTokens.text.secondary,
    },
    "&:hover:not(.Mui-checked) .MuiCheckbox-checkbox": {
      borderColor: colorTokens.accent.primary,
      backgroundColor: colorTokens.text.primary,
    },
    "&.Mui-checked .MuiCheckbox-checkbox": {
      backgroundColor: colorTokens.accent.primary,
      borderColor: colorTokens.accent.primary,
      color: colorTokens.accent.contrastText,
    },
    "&.Mui-focusVisible .MuiCheckbox-checkbox": {
      outline: `2px solid ${withAlpha(colorTokens.accent.primary, 0.35)}`,
      outlineOffset: "2px",
    },
    "&.Mui-disabled": {
      opacity: 0.55,
    },
    "&.Mui-disabled .MuiCheckbox-label": {
      color: colorTokens.text.muted,
    },
    ...sx,
  };

  return <Checkbox ref={ref} sx={darkCheckboxStyles} {...other} />;
});

DarkCheckbox.displayName = "DarkCheckbox";

export default DarkCheckbox;
